<!--
 * @Description: 教职工详情 外籍教师聘用
 * @Author: 张天伟
 * @Date: 2023-03-08 17:10:02
 * @LastEditors: 张天伟
 * @LastEditTime: 2023-03-09 13:56:38
-->

<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
        <el-descriptions-item label="国内体检号" label-align="right" align="left" width="120px" span="2">{{item.gntjh}}</el-descriptions-item>
        <el-descriptions-item label="国外体检号" label-align="right" align="left" width="120px" span="2">{{item.gwtjh}}</el-descriptions-item>
        <el-descriptions-item label="国内体检日期" label-align="right" align="left" width="120px" span="2">{{item.gntjrq}}</el-descriptions-item>
        <el-descriptions-item label="国外体检日期" label-align="right" align="left" width="120px" span="2">{{item.gwtjrq}}</el-descriptions-item>
        <el-descriptions-item label="签证种类" label-align="right" align="left" width="120px" span="2">{{item.qzzlbt}}</el-descriptions-item>
        <el-descriptions-item label="临时住宿登记" label-align="right" align="left" width="120px" span="2">{{item.lszsdj}}</el-descriptions-item>
        <el-descriptions-item label="住宿地址" label-align="right" align="left" width="120px" span="2">{{item.zsdz}}</el-descriptions-item>
        <el-descriptions-item label="专家证号" label-align="right" align="left" width="120px" span="2">{{item.zjzh}}</el-descriptions-item>
        <el-descriptions-item label="居留许可号" label-align="right" align="left" width="120px" span="2">{{item.jlxkh}}</el-descriptions-item>
        <el-descriptions-item label="居留开始日期" label-align="right" align="left" width="120px" span="2">{{item.jlksrq}}</el-descriptions-item>
      </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongwaijijiaoshipinyong/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
